module.exports = __webpack_public_path__ + "278635d810ed40b3ca96a3142a554000.svg";